/* Gift Guides article: contents list, scroll highlight, product cards next to the text. */
(function () {
  var root = document.querySelector('[data-article-guide]');
  if (!root) return;
  var body = root.querySelector('.ag-rte');
  var toc = root.querySelector('.ag-toc');
  if (!body) return;

  var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
  var used = {};
  function slug(t) {
    var s = (t || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    var base = s, n = 2;
    while (used[s] || (document.getElementById(s) && document.getElementById(s) !== null)) s = base + '-' + n++;
    used[s] = true;
    return s;
  }
  heads.forEach(function (h) { if (!h.id) h.id = slug(h.textContent); });

  // Contents list (desktop only via CSS; hidden if fewer than 3 sections)
  var links = {};
  if (toc && heads.length >= 3) {
    var ol = toc.querySelector('ol');
    heads.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/\s+/g, ' ').trim();
      li.appendChild(a);
      ol.appendChild(li);
      links[h.id] = a;
    });
    toc.hidden = false;
  }

  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }
  // Product card after the first paragraph that links each product
  var tpl = document.getElementById('ag-inline-cards');
  if (tpl && tpl.content) {
    var placed = {};
    Array.prototype.forEach.call(tpl.content.querySelectorAll('.ag-card'), function (card) {
      var h = card.getAttribute('data-handle');
      var link = Array.prototype.find.call(body.querySelectorAll('a[href*="/products/"]'), function (a) { return handleOf(a) === h; });
      if (!link || placed[h]) return;
      var block = link;
      while (block.parentElement && block.parentElement !== body) block = block.parentElement;
      if (block.parentElement !== body) return;
      block.insertAdjacentElement('afterend', card.cloneNode(true));
      placed[h] = true;
    });
  }

  // Scroll highlight: current section in the contents
  var active = null;
  function setActive(id) {
    if (id === active) return;
    active = id;
    Object.keys(links).forEach(function (k) { links[k].setAttribute('aria-current', k === id ? 'true' : 'false'); });
  }
  if (!heads.length || !Object.keys(links).length) return;
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var id = null;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].getBoundingClientRect().top < 220) id = heads[i].id; else break;
      }
      setActive(id);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
